
    import {defineComponent, h, nextTick, reactive} from 'vue'
    import {useRoute, useRouter} from "vue-router";
    import  reportMsgUt from "@/util/reportMsg";
    import {useStore} from '@/store';
    import { Toast } from 'scvant';
    import {GetReportViewModelFromJSON, GetReportViewModelFromServe, GetVerifyEffectiveReport, GetOldReportPdfUrl} from '@/service'

    let nameList = [
        'navigation',
        'HeadTip',
        'CarNameVin',
        // 'SwiperBanner',
        'LoopCarVideo',
        'BaseInfo',
        // 'ConfigurationInfo',
        'Entrust',
        'CheckCont',
        'entrustQuery',
        'EcuCheck',
        'RemarksMsg',
        'detectMsg',
        'EnsureService',
        'ReminderText',
    ]
    let list: any[] = [];
    let components = {};
    nameList.forEach(item => {
        if (!components[item]) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const model = require(`./_components/${item}.vue`)['default'];
            list.push(model)
            components[item] = model
        } else {
            list.push(components[item])
        }
    });
    interface State {
        reportMsg: object;
    }
    export default defineComponent({
        name: "h5_index",
        components,
        setup() {
            let state: State = reactive({
                reportMsg: {}
            })
            state.reportMsg = reportMsgUt;
            document.title= "检测认证评估报告";
            const {query} = useRoute();
            const router = useRouter();
            const {reportCode, templateCode, reportVersion, targetPage} = query;
            let store = useStore()
            if (targetPage === 'photo_mark') {
                let queryCopy = JSON.parse(JSON.stringify(query));
                delete(queryCopy.targetPage);
                sessionStorage.setItem('targetPage', 'photo_mark');
                console.log('queryCopy', queryCopy);
                router.replace({
                    path: '/tocV3',
                    query: queryCopy
                })
            }
            // 直链接口
            // GetReportViewModelFromServe({reportCode, templateCode}).then((res: any) => {
            //     store.dispatch('saveDataInfo', res)
            // }).catch((err) => {
            //     // eslint-disable-next-line
            //     console.error(err)
            // })
            // 先尝试json文件
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '加载中...',
            });
            function setReportResultList (res) {
                const { isAccident, isFire, isWater, accidentFlag, newAccidentRule } = res;
                console.log('newAccidentRule:', newAccidentRule);
                if (!newAccidentRule) {
                    let normal = (accidentFlag === 0 || accidentFlag === 1 || !isAccident) && !isFire && !isWater;
                    store.dispatch('saveIsNormal', normal);
                    let resultList = [{
                        src: require('../../assets/tocV3/accident.png'),
                        otherSrc: require('../../assets/tocV3/accident1.png'),
                        baseSrc: require('../../assets/tocV3/accidentNo.png'),
                        name: accidentFlag === 2 ? '重大事故车' : (accidentFlag === 1 ? '非重大事故车' : '非事故车'),
                        isErr: accidentFlag === 2 ? 1 : 0
                    },
                    {
                        src: require('../../assets/tocV3/water.png'),
                        baseSrc: require('../../assets/tocV3/waterNo.png'),
                        name: isWater ? '泡水车' : '非泡水车',
                        isErr: isWater
                    },
                    {
                        src: require('../../assets/tocV3/fire.png'),
                        baseSrc: require('../../assets/tocV3/fireNo.png'),
                        name: isFire ? '火烧车' : '非火烧车',
                        isErr: isFire
                    }];
                    store.dispatch('saveReportResultList', resultList);
                } else {
                    let normal = !isFire && !isWater && (accidentFlag === 0 || accidentFlag === 1);
                    store.dispatch('saveIsNormal', normal);
                    let resultList = [{
                        src: require('../../assets/tocV3/accident.png'),
                        otherSrc: require('../../assets/tocV3/accident1.png'),
                        baseSrc: require('../../assets/tocV3/accidentNo.png'),
                        name: accidentFlag === 2 ? '重大事故车' : (accidentFlag === 1 ? '事故车' : '非事故车'),
                        isErr: accidentFlag === 2 ? 1 : (accidentFlag === 1 ? 2 : 0)
                    },
                    {
                        src: require('../../assets/tocV3/water.png'),
                        baseSrc: require('../../assets/tocV3/waterNo.png'),
                        name: isWater ? '泡水车' : '非泡水车',
                        isErr: isWater
                    },
                    {
                        src: require('../../assets/tocV3/fire.png'),
                        baseSrc: require('../../assets/tocV3/fireNo.png'),
                        name: isFire ? '火烧车' : '非火烧车',
                        isErr: isFire
                    }
                    ];
                    store.dispatch('saveReportResultList', resultList);
                }
            }
            GetReportViewModelFromJSON({reportCode, reportVersion, templateCode}).then((res: any) => {
                store.dispatch('saveDataInfo', res)
                console.log('saveDataInfos:', res);
                setReportResultList(res);
                nextTick(() => {
                    window.scrollTo(0, store.state.pageScrollTop)
                    store.dispatch('savePageScrollTop', 0);
                });
                Toast.clear();
                let targetPage = sessionStorage.getItem('targetPage');
                sessionStorage.removeItem('targetPage');
                if (targetPage === 'photo_mark') {
                    let queryCopy = JSON.parse(JSON.stringify(query));
                    delete(queryCopy.targetPage);
                    router.replace({
                        path: '/tocV3',
                        query: queryCopy
                    })
                    router.push({
                        path:'/tocV3PhotoList',
                        query: {
                            photoCode: res.markPhotoList[0].photoIdStr,
                            group: 'mark',
                            templateCode: templateCode
                        }
                    })
                }
            }).catch((err) => {
                if (err.message.indexOf('404')) {
                    // json文件404了请求直连接口
                    Toast.loading({
                        duration: 0,
                        forbidClick: true,
                        message: '加载中...',
                    });
                    GetReportViewModelFromServe({reportCode, templateCode, reportVersion}).then((res: any) => {
                        store.dispatch('saveDataInfo', res)
                        setReportResultList(res);
                        nextTick(() => {
                            window.scrollTo(0, store.state.pageScrollTop)
                            store.dispatch('savePageScrollTop', 0);
                        });
                        Toast.clear();
                        let targetPage = sessionStorage.getItem('targetPage');
                        sessionStorage.removeItem('targetPage');
                        if (targetPage === 'photo_mark') {
                            let queryCopy = JSON.parse(JSON.stringify(query));
                            delete(queryCopy.targetPage);
                            router.replace({
                                path: '/tocV3',
                                query: queryCopy
                            })
                            router.push({
                                path:'/tocV3PhotoList',
                                query: {
                                    photoCode: res.markPhotoList[0].photoIdStr,
                                    group: 'mark',
                                    templateCode: templateCode
                                }
                            })
                        }
                    }).catch((err) => {
                        console.error(err)
                    })
                } else {
                    console.error(err)
                }
            })
            return {
                state,
                store
            }
        },
        render() {
            let className='';
            if (this.state.reportMsg['RpZB']()) {
                className = 'toc_main__bg_color';
            } else if (this.state.reportMsg['RpCK']()) {
                className = 'toc_main__bg_color';
            } else {
                className = 'toc_main__bg_color';
            }
            return h('keep-alive',{include: ''}, [h('div', {class: className}, list.map((item, index) =>
                h(item, {}, index)
            ))]);
        },
        // beforeUnmount() {
        //     this.store.dispatch('savePageScrollTop', 0)
        // },
        beforeRouteEnter(to, from, next) {
            // const {reportCode, templateCode} = to.query;
            const {reportCode, reportVersion, templateCode, targetPage} = to.query;
            let time = 0;
            if (reportCode && typeof reportCode === 'string') {
                time = Number(reportCode.substring(2));
            }
            const batTime = 230525183151001;
            function jump () {
                if (!templateCode) {
                    to.query.templateCode = 'no_cert_report';
                }
                if(`${reportCode}`.indexOf('DE') > -1) {
                    let isClose = true;
                    GetVerifyEffectiveReport({reportCode}).then((res: any) => {
                        isClose = res;
                        if (!isClose) {
                            next('/deffectiveReport')
                        } else {
                            next();
                        }
                    }).catch(() => {
                        next();
                    });
                } else {
                    next();
                }
            }
            if (time<batTime && !targetPage) {
                console.log('cccccccccc');
                let opt = {
                    reportCode,
                    reportVersion,
                    templateCode
                };
                GetOldReportPdfUrl(opt).then((res: any) => {
                    if (res) {
                        next({
                            path: '/viewPDF',
                            query: {
                                'pdfurl': encodeURIComponent(res)
                            }
                        })
                    } else {
                        jump();
                    }
                });
                
            } else {
                jump();
            }
            
        }
    });
